import { render } from "./shellfish_page.vue?vue&type=template&id=5a2eea2a&scoped=true"
import script from "./shellfish_page.vue?vue&type=script&lang=js"
export * from "./shellfish_page.vue?vue&type=script&lang=js"

import "./shellfish_page.vue?vue&type=style&index=0&id=5a2eea2a&scoped=true&lang=css"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/RiverWQApp_Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2eea2a"]])

export default __exports__